import { render } from "./glob-virtual-table.vue?vue&type=template&id=fd30db52&scoped=true"
import script from "./glob-virtual-table.vue?vue&type=script&lang=js"
export * from "./glob-virtual-table.vue?vue&type=script&lang=js"

import "./glob-virtual-table.vue?vue&type=style&index=0&id=fd30db52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd30db52"]])

export default __exports__